import { render, staticRenderFns } from "./RecordSTable.vue?vue&type=template&id=7219d153"
import script from "./RecordSTable.vue?vue&type=script&lang=js"
export * from "./RecordSTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports